import { getConfig } from 'config'

const config = await getConfig()

export const AppStoreImage = `${config.blobAssetUrl}AppStore.png`
export const CarChargingImage = `${config.blobAssetUrl}CarCharging.jpg`
export const ChargerStepImage = `${config.blobAssetUrl}ChargerStep.jpg`
export const GarageImage = `${config.blobAssetUrl}Garage.jpg`
export const GarageCarsImage = `${config.blobAssetUrl}GarageCars.jpg`
export const GooglePlayImage = `${config.blobAssetUrl}GooglePlay.png`
export const HomeGarageImage = `${config.blobAssetUrl}HomeGarage.jpg`
export const InstallerDoneImage = `${config.blobAssetUrl}InstallerDone.jpg`

export const rfidPrivateImage = `${config.blobAssetUrl}rfid-card-private.jpg`
export const rfidBusinessImage = `${config.blobAssetUrl}rfid-card-business.jpg`
export const modalRfidBusinessCardFocusImage = `${config.blobAssetUrl}modal-business-card-number-focus.jpg`
export const modalRfidBusinessSuccessImage = `${config.blobAssetUrl}modal-business-card-success.jpg`
export const modalRfidPrivateCardFocusImage = `${config.blobAssetUrl}modal-private-card-number-focus.jpg`
export const modalRfidPrivateSuccessImage = `${config.blobAssetUrl}modal-private-card-success.jpg`
export const ExternalRfidCardImage = `${config.blobAssetUrl}rfid-card-external.png`
export const modalExternalRfidCardFocusImage = `${config.blobAssetUrl}modal-external-card-number-focus.png`

export const HeaderHomeImage = `${config.blobAssetUrl}HeaderHome.png`
export const HeaderHomeMobileImage = `${config.blobAssetUrl}HeaderHomeMobile.png`
export const ReimbursementImage = `${config.blobAssetUrl}envision-women-plugin-charging-cable-garage.jpg`
export const MobileAppImage = `${config.blobAssetUrl}MobileAppUnivers.jpg`
export const FleetChargingImage = `${config.blobAssetUrl}FleetCharging.jpg`

// Replacing `export const` with `import` for Nissan images
// TODO:: Confirm that there are no usages of Nissan images and remove them
// import HeaderHomeImage_nissan from '../assets/images/HeaderHome_nissan.jpg'
// import HeaderHomeMobileImage_nissan from '../assets/images/HeaderHomeMobile_nissan.jpg'
// import HeaderCheckoutImage_nissan from '../assets/images/HeaderCheckout_nissan.jpg'
// import HeaderCheckoutMobileImage_nissan from '../assets/images/HeaderCheckoutMobile_nissan.jpg'

export const GridChargerIcon = `${config.blobAssetUrl}GridCharger.png`

export const IMAGES = [
  ChargerStepImage,
  GarageCarsImage,
  InstallerDoneImage,
  GarageImage,
  MobileAppImage,
  CarChargingImage,
  HomeGarageImage,
  AppStoreImage,
  GooglePlayImage,
  HeaderHomeImage,
  HeaderHomeMobileImage,
  GridChargerIcon,
]
